import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface DashboardPeriod {
  month: number;
  year: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardPeriodService {
  private readonly periodSubject = new BehaviorSubject<DashboardPeriod>(this.getDefaultPeriod());

  readonly period$ = this.periodSubject.asObservable();

  get current(): DashboardPeriod {
    return this.periodSubject.value;
  }

  setPeriod(period: DashboardPeriod): void {
    this.periodSubject.next({
      month: Number(period?.month ?? 0),
      year: Number(period?.year ?? new Date().getFullYear())
    });
  }

  private getDefaultPeriod(): DashboardPeriod {
    const now = new Date();
    return { month: now.getMonth(), year: now.getFullYear() };
  }
}
